<template>
  <div>
    <el-checkbox style="margin-bottom: 16px;" v-model="warnState" :true-label="1" :false-label="0">警告通知</el-checkbox>
    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 40}" v-model="msg" maxlength="200" placeholder="请输入1000字以内的小助手通知消息"/>
    <div style="margin: 16px 0 8px;">
      <el-checkbox v-model="check1" @change="checkChange(1)">{{msg1}}</el-checkbox>
      <el-checkbox v-model="check2" @change="checkChange(2)">{{msg2}}</el-checkbox>
    </div>
    <div class="dialog-footer" style="text-align: left;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">发送通知</el-button>
    </div>
  </div>
</template>

<script>
import { sendSystemMessage } from "@/api/url";
import { postFormData } from "@/api/api";

export default {
  name: "SendSystemMessage",
  props: {
    value: Object
  },
  data() {
    return {
      userIdArray: this.value.userIdArray,
      msg: '',
      msg1: '最近你存在被用户举报的记录，请遵守平台规则，再次违规将会被禁言',
      msg2: '最近系统继续收到你被举报的记录，请遵守平台规则，再次违规将会被封号',
      loading: false,
      warnState: 0,
      check1: false,
      check2: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    checkChange(s) {
      if(s == 1) {
        this.check2 = false
        this.msg = this.msg1
      }
      if(s == 2) {
        this.check1 = false
        this.msg = this.msg2
      }
    },

    submit() {
      if ( !this.msg ) {
        this.$message({
          message: '通知内容不能为空',
          duration: 2000,
          type: 'warning'
        })
        return  false
      }
      this.loading = true
      let param = {}
      param['idArr'] = this.userIdArray
      param['content'] = this.msg
      param['warnState'] = this.warnState
      postFormData(sendSystemMessage, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }

  }

}
</script>

<style scoped>

</style>
